import React from 'react';

export const WindowsIcon = ({ className = 'h-7 w-7' }) => (
  <svg className={className} viewBox="0 0 88 88" aria-hidden="true">
    <path
      fill="#F25022"
      d="M0 12.402l35.687-4.86.016 34.423L0 46.199V12.402z"
    />
    <path
      fill="#00A4EF"
      d="M35.67 33.966l.028 34.453L.028 75.988 0 41.606l35.67 4.762z"
    />
    <path
      fill="#7FBA00"
      d="M39.996 7.066l46.002-6.261v41.394l-46.002.057V7.066z"
    />
    <path
      fill="#FFB900"
      d="M46.002 37.786v41.443l-46.002 6.281.031-47.522 45.971-.202z"
    />
  </svg>
);

export const AppleIcon = ({ className = 'h-7 w-7' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.365 1.43c0 1.14-.417 2.087-1.249 2.84-.895.812-1.966 1.218-3.116 1.152-.045-1.09.398-2.08 1.249-2.84.851-.761 1.922-1.167 3.116-1.152zM20.5 17.063c-.583 1.333-.857 1.928-1.604 3.106-1.04 1.658-2.508 3.727-4.325 3.743-1.214.013-1.926-.78-3.571-.78-1.646 0-2.126.767-3.595.793-1.438.026-2.534-1.445-3.574-3.1-1.953-3.12-3.437-8.886-.945-12.773.24-.414 1.338-1.893 2.749-1.91 1.07-.014 1.753.72 3.02.72 1.235 0 1.987-.72 3.758-.72 1.344.022 2.5 1.126 2.717 1.544-2.388 1.345-2.002 4.835.365 5.677z" />
  </svg>
);

export const PlatformIconBadge = ({ platform }) => {
  const PlatformIcon = platform.Icon;
  const badgeSizeClass = platform.iconBadgeClass || 'h-11 w-11';
  const imageSizeClass = platform.iconSizeClass || 'h-8 w-8';

  return (
    <div
      className={`flex ${badgeSizeClass} shrink-0 items-center justify-center rounded-xl ring-1 ring-white/10 ${platform.iconBgClass}`}
    >
      {platform.iconSrc ? (
        <img
          src={platform.iconSrc}
          alt={platform.iconAlt || `${platform.title} logosu`}
          className={`${imageSizeClass} object-contain`}
        />
      ) : (
        <PlatformIcon className={platform.iconClassName || 'h-7 w-7'} />
      )}
    </div>
  );
};
